import * as Yup from "yup";
const VALIDATE_MESSAGE = {
  required: "Thông tin bắt buộc"
};

export const ValidateSchema = Yup.object().shape({
  tenSanPham: Yup.string()
    .nullable()
    .required(VALIDATE_MESSAGE.required),
  nhomSanPham: Yup.object()
    .shape({
      tenDanhMuc: Yup.string()
    })
    .nullable()
    .required(VALIDATE_MESSAGE.required)

  // idNhomSanPham: Yup.number()
  //   .nullable()
  //   .required(VALIDATE_MESSAGE.required),
  // idCoSoSanXuat: Yup.number()
  //   .nullable()
  //   .required(VALIDATE_MESSAGE.required)
});
